import axios from "axios";

export interface TransliterateOptionsJa {
  input: string;
  from: "ja";
  to?: "katakana" | "romaji";
  romajiSystem?: "passport" | "hepburn" | "nippon";
}

export interface TransliterateOptionsZh {
  input: string;
  from: "zh";
  to?: "normal" | "tone";
}

export type TransliterateOptions =
  | TransliterateOptionsJa
  | TransliterateOptionsZh
  | {
      input: string;
      from?: string;
      to?: string;
    };

export const TRANSLITERATE_API_URL =
  process.env.REACT_APP_TRANSLITERATE_API_URL ||
  // @TODO change to prod version when CORS works
  // "https://exprimer.toolkit.lvmhda.com"
  "https://exprimer-nonprod.toolkit.lvmhda.com";

export default async function transliterate(payload: TransliterateOptions) {
  try {
    const { output = payload.input } = await axios
      .post(`${TRANSLITERATE_API_URL}`, payload)
      .then(res => res.data);
    return output;
  } catch (error) {
    console.error(error);
    return payload.input;
  }
}
